// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tl-logo__wrapper[data-v-774256a1]{width:150px}", ""]);
// Exports
module.exports = exports;
